import * as editCoordinators from './edit'

export default Object.freeze({
  ...editCoordinators,
})
